var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "media-player",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7304",
    "data-name": "Group 7304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7302",
    "data-name": "Group 7302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17771",
    "data-name": "Path 17771",
    d: "M20.5,5A2.5,2.5,0,1,1,23,2.5,2.5,2.5,0,0,1,20.5,5Zm0-4A1.5,1.5,0,1,0,22,2.5,1.5,1.5,0,0,0,20.5,1Z",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7303",
    "data-name": "Group 7303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17772",
    "data-name": "Path 17772",
    d: "M23.5,6a.5.5,0,0,1-.354-.146l-1.5-1.5a.5.5,0,1,1,.707-.707l1.5,1.5A.5.5,0,0,1,23.5,6Z",
    fill: "#0080ff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7305",
    "data-name": "Group 7305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17773",
    "data-name": "Path 17773",
    d: "M14.5,6H1.5A1.5,1.5,0,0,1,0,4.5v-3A1.5,1.5,0,0,1,1.5,0h13A1.5,1.5,0,0,1,16,1.5v3A1.5,1.5,0,0,1,14.5,6ZM1.5,1a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5Z",
    fill: "#0080ff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7306",
    "data-name": "Group 7306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17774",
    "data-name": "Path 17774",
    d: "M3,14a3,3,0,1,1,3-3A3,3,0,0,1,3,14ZM3,9a2,2,0,1,0,2,2A2,2,0,0,0,3,9Z",
    fill: "#0080ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7307",
    "data-name": "Group 7307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17775",
    "data-name": "Path 17775",
    d: "M5.5,20H.5a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z",
    fill: "#0080ff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7308",
    "data-name": "Group 7308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17776",
    "data-name": "Path 17776",
    d: "M5.5,23H.5a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z",
    fill: "#0080ff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7309",
    "data-name": "Group 7309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17777",
    "data-name": "Path 17777",
    d: "M5.5,17H.5a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z",
    fill: "#0080ff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7310",
    "data-name": "Group 7310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17778",
    "data-name": "Path 17778",
    d: "M22.5,24H9.5A1.5,1.5,0,0,1,8,22.5V9.5A1.5,1.5,0,0,1,9.5,8h13A1.5,1.5,0,0,1,24,9.5v13A1.5,1.5,0,0,1,22.5,24ZM9.5,9a.5.5,0,0,0-.5.5v13a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5V9.5a.5.5,0,0,0-.5-.5Z",
    fill: "#0080ff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7311",
    "data-name": "Group 7311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17779",
    "data-name": "Path 17779",
    d: "M13.5,19a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,.723-.447l6,3a.5.5,0,0,1,0,.894l-6,3A.5.5,0,0,1,13.5,19Zm.5-5.691v4.383L18.382,15.5Z",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.286cf443.svg";
export { ForwardRef as ReactComponent };